<div class="chart" width="100px;">
  <div
    [id]="id"
    class="charts"
    style="width: 100%"
    [style.height.px]="graphHeight"
  ></div>
</div>
